import React, { Component } from 'react';
import classnames from 'classnames';

import './EditEntityModal.css';

// Entity type forms
import EditEntityForm_0 from './TypeForms/Type_0/EditEntityForm_0';
import EditEntityForm_1 from './TypeForms/Type_1/EditEntityForm_1';
import EditEntityForm_2 from './TypeForms/Type_2/EditEntityForm_2';
import EditEntityForm_3 from './TypeForms/Type_3/EditEntityForm_3';

// API Functions
import { editEntity_0, editEntity_1, editEntity_2, editEntity_3 } from './EditEntityModalAPI';

class EditEntityModal extends Component {

  static defaultProps = {
    quitEntityEditModal : () => {
      
    },
    selectedEntityType : null,
    editTargetEntity : null,
  }

  SYNONYM_START_STR = "{:{";
  SYNONYM_END_STR = "}:}";
  SYNONYM_DIVIDER_STR = "\t";
  // SYNONYM_START_STR = "(";
  // SYNONYM_END_STR = ")";
  // SYNONYM_DIVIDER_STR = "\t";

  componentWillUpdate() {
    
    
  }

  handleQuitEntityEditModal = (e) => {
    e.stopPropagation();
    this.props.quitEntityEditModal();
  }

  handleEditEntity_0 = (entityId, entityName, entityLanguage, entitySynonyms) => {
    this.editEntity_0Wrapper(entityId, entityName, entityLanguage, entitySynonyms);
    // if (entitySynonyms.length <= 0) {
    //   if (window.confirm("Synonym 엔티티가 존재하지 않습니다. 그래도 수정 하시겠습니까?")) {
    //     this.editEntity_0Wrapper(entityId, entityName, entityLanguage, entitySynonyms);
    //   }
    // } else {
    //   this.editEntity_0Wrapper(entityId, entityName, entityLanguage, entitySynonyms);
    // }
  }
  editEntity_0Wrapper = (entityId, name, language, entitySynonyms) => {
    
    const entitySynonyms_toParamData = entitySynonyms.map( (entitySynonym, i) => {
      let entity_string = "";
      entity_string += entitySynonym.name;
      // synonym이 존재 할 경우 추가로직 수행(not normal value)
      if (entitySynonym.synonyms && entitySynonym.synonyms.length > 0) {
        const { synonyms } = entitySynonym;
        entity_string += this.SYNONYM_START_STR;

        synonyms.map( (synonym, i) => {
          entity_string += synonym;
          if (synonyms.length !== i+1) { entity_string += this.SYNONYM_DIVIDER_STR; } // divider string
        })

        entity_string += this.SYNONYM_END_STR;
      }
      return entity_string;
    })
    

    editEntity_0(this.editEntity_0_callBack, this.editEntity_0_errorCallBack, 
      entityId, 
      0,
      name,
      entitySynonyms_toParamData,
      language, 
      );
  }
  editEntity_0_callBack = (response) => {
    
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { property } = data;
      const { entity } = property;
      // type 0 수정 response 필요 값
      const { id } = entity;
      const { entityName } = entity;
      const { value } = entity;
      const { language } = entity;
      
      
      
      
      this.props.updateEntity(0, id, entityName, language, value);
      break;
      
      case 403:
      alert("중복된 엔티티 이름입니다.");
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
      break;

      default:
      alert("에러가 발생하였습니다.");
      break;

    }
  }
  editEntity_0_errorCallBack = (error) => {
    alert("서버와 통신하는 도중에 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
    
  }
  
  handleEditEntity_1 = (entityId, entityName, entityLanguage, entityValue) => {
    if (entityValue.trim() === "") {
      if (window.confirm("정규식이 입력되지 않았습니다. 그래도 수정 하시겠습니까?")) {
        this.editEntity_1Wrapper(entityId, entityName, entityLanguage, entityValue);
      }
    } else {
      this.editEntity_1Wrapper(entityId, entityName, entityLanguage, entityValue);
    }
  }
  editEntity_1Wrapper = (entityId, name, language, entityValue) => {
    
    editEntity_1(this.editEntity_1_callBack, this.editEntity_1_errorCallBack, 
      entityId, 
      1,
      name,
      entityValue,
      language, 
      );
  }
  editEntity_1_callBack = (response) => {
    
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { property } = data;
      const { entity } = property;
      // type 0 수정 response 필요 값
      const { id } = entity;
      const { entityName } = entity;
      const { value } = entity;
      const { language } = entity;
      
      
      
      
      this.props.updateEntity(1, id, entityName, language, value);
      break;
      
      case 403:
      alert("중복된 엔티티 이름입니다.");
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
      break;

      default:
      alert("에러가 발생하였습니다.");
      break;

    }
  }
  editEntity_1_errorCallBack = (error) => {
    alert("서버와 통신하는 도중에 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
    
  }

  handleEditEntity_2 = (entityId, entityName, entityLanguage, entityValue, editFunction) => {
    if (entityValue.trim() === "") {
      if (window.confirm("정규식이 입력되지 않았습니다. 그래도 수정 하시겠습니까?")) {
        this.editEntity_2Wrapper(entityId, entityName, entityLanguage, entityValue, editFunction);
      }
    } else {
      this.editEntity_2Wrapper(entityId, entityName, entityLanguage, entityValue, editFunction);
    }
  }
  editEntity_2Wrapper = (entityId, name, language, entityValue, editFunction) => {
    
    editEntity_2(this.editEntity_2_callBack, this.editEntity_2_errorCallBack, 
      entityId, 
      2,
      name,
      entityValue,
      language, 
      editFunction,);
  }
  editEntity_2_callBack = (response) => {
    
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { property } = data;
      const { entity } = property;
      // type 0 수정 response 필요 값
      const { id } = entity;
      const { entityName } = entity;
      const { value } = entity;
      const { language } = entity;
      const entityFunction = entity.function;
      
      
      
      
      
      this.props.updateEntity(2, id, entityName, language, value, entityFunction);
      break;
      
      case 403:
      alert("중복된 엔티티 이름입니다.");
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
      break;

      default:
      alert("에러가 발생하였습니다.");
      break;

    }
  }
  editEntity_2_errorCallBack = (error) => {
    alert("서버와 통신하는 도중에 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
    
  }

  handleEditEntity_3 = (entityId, entityName, entityLanguage, memberEntities) => {
    
    this.editEntity_3Wrapper(entityId, entityName, entityLanguage, memberEntities);
  }
  editEntity_3Wrapper = (entityId, name, language, memberEntities) => {
    
    editEntity_3(this.editEntity_3_callBack, this.editEntity_3_errorCallBack, 
      entityId, 
      3,
      name,
      language,
      memberEntities);
  }
  editEntity_3_callBack = (response) => {
    
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { property } = data;
      const { entity } = property;
      
      // type 0 수정 response 필요 값
      const { id } = entity;
      const { entityName } = entity;
      const { language } = entity;
      const { entities } = entity;

      this.props.updateEntity(3, id, entityName, language, null, null, entities);
      break;
      
      case 403:
      alert("중복된 엔티티 이름입니다.");
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
      break;

      default:
      alert("에러가 발생하였습니다.");
      break;

    }
  }
  editEntity_3_errorCallBack = (error) => {
    alert("서버와 통신하는 도중에 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
    
  }

  render() { 
    
    const formRender = () => {
      if (this.props.isShow) {
        if (!this.props.selectedEntityType && typeof this.props.selectedEntityType !== 'number') {
          return (
            <p> 선택된 엔티티 타입이 없습니다. </p>
          )
        }
        
        switch(this.props.selectedEntityType) {
          case 0:
          return (
            <EditEntityForm_0
              editTargetEntity={this.props.editTargetEntity}
              editEntity={this.handleEditEntity_0}
              updateEntityName={this.props.updateEntityName} />
          )
  
          case 1: 
          return (
            <EditEntityForm_1
              editTargetEntity={this.props.editTargetEntity}
              editEntity={this.handleEditEntity_1}
              updateEntityName={this.props.updateEntityName} />
          )
  
          case 2:
          
          return (
            <EditEntityForm_2
              editTargetEntity={this.props.editTargetEntity}
              editEntity={this.handleEditEntity_2}
              updateEntityName={this.props.updateEntityName} />
          )
  
          case 3:
          return (
            <EditEntityForm_3
              topicId={this.props.topicId}
              editTargetEntity={this.props.editTargetEntity}
              editEntity={this.handleEditEntity_3}
              updateEntityName={this.props.updateEntityName} 
              updateEntityLanguage={this.props.updateEntityLanguage}
              importEntity={this.props.importEntity}
              exportEntity={this.props.exportEntity}
              deleteOwnRegex={this.props.deleteOwnRegex}
              toggleExpand={this.props.toggleExpand}
              ownRegexToggleExpand={this.props.ownRegexToggleExpand}
              updateOwnRegex={this.props.updateOwnRegex} />
          )
  
          default:
  
        }
      } 
    }

    const whiteSpace_classNames = classnames({
      "white-space" : this.props.isShow,
      "second-modal-white-space" : this.props.isShow,
      "show" : (this.props.isShow ? true : false),
      "hide" : (this.props.isShow ? false : true),
    })

    return (
      <React.Fragment>
        <div
          onClick={this.handleQuitEntityEditModal} 
          className={whiteSpace_classNames}>
        </div>
        <div id="EditEntityModal"
          className={ this.props.isShow ? "show" : "hide" }
          onClick={e => {e.stopPropagation();}}>
          <div className="header">
            <p className="title"> 엔티티 수정 </p>
          </div>
          <div className="body">
            {formRender()}
          </div>
          {/* <div className="bottom">

          </div> */}
        </div>
      </React.Fragment>
      
    );
  }
}
 
export default EditEntityModal;